import { PRICE_POLICIES_SET_VIN } from '../constants'

export function reducer(state, action) {
    if (action.type === PRICE_POLICIES_SET_VIN) {
        return {
            ...state,
            vin: action.data.vin,
        }
    } else {
        return state
    }
}